




















import { Component, Vue } from 'vue-property-decorator';
import TodoList from './components/todoList.vue';
import SelectModule from '@/components/selectModule.vue';
import { pubsub, UPDATE_TODO_BONUS_EVENT, BATCH_CREATED_TODO_EVENT } from '@/utils/pubsub';
import { statusList } from '@/utils/todo';
import { todoListInstance } from '@/model/TodoListClass';
import moment, {Moment} from 'moment';

let updateTodoBonusEventToken = '';
let batchCreatedTodoEventToken = '';
const STATUS_OPTIONS: ITodo.ITodoStatus[] = statusList;


@Component({
  name: 'Todo',
  components: {
    TodoList,
    SelectModule,
  },
})
export default class Todo extends Vue {
  private statusOptions: Array<ITodo.ITodoStatus | 'All'> = ['All', ...STATUS_OPTIONS];
  private dateInterval: Moment[] = [];
  private searchByStatus: ITodo.ITodoStatus | 'All' = 'All';
  private todoListInstance = todoListInstance;
  private listSpinning = false;
  get remindRefresh() {
    return this.todoListInstance.remindRefresh;
  }
  get placeholder(): string[] {
    return [
      this.$t('todo.due').toString() + ' ' + this.$t('operation.start').toString(),
      this.$t('todo.due').toString() + ' ' + this.$t('operation.end').toString(),
    ];
  }
  private created() {
    this.bindEvent();
    this.initTodos();
  }
  private destroyed() {
    this.unBindEvent();
    this.todoListInstance.list.clearData();
  }
  private refreshTodos() {
    this.dateInterval = [];
    this.searchByStatus = 'All';
    this.todoListInstance.remindRefresh = false;
    this.initTodos();
  }
  private handleSearch() {
    const params: ITodo.IRequest.ISearchTodo = {};
    if (this.searchByStatus && this.searchByStatus !== 'All' ) {
      params.status = this.searchByStatus;
    }
    if (this.dateInterval.length >= 2) {
      params.startDate = this.dateInterval[0].startOf('d').format('YYYY-MM-DD HH:mm:ss');
      params.endDate = this.dateInterval[1].endOf('d').format('YYYY-MM-DD HH:mm:ss');
    }
    this.initTodos(params);
  }
  private initTodos(params?: ITodo.IRequest.ISearchTodo) {
    this.listSpinning = true;
    todoListInstance.requestData(params).catch((err) => {
      this.$message.warning(err);
    }).finally(() => {
      this.listSpinning = false;
    });
  }
  private goModulePage(moduleId: string) {
    this.$router.push({
      name: 'Module',
      params: {
        id: moduleId,
      },
    });
  }
  private bindEvent() {
    updateTodoBonusEventToken = pubsub.subscribe(UPDATE_TODO_BONUS_EVENT, (message: string, todoIds: string[]) => {
      todoListInstance.updateTodoBonus(todoIds);
    });
    batchCreatedTodoEventToken = pubsub.subscribe(BATCH_CREATED_TODO_EVENT, (message: string) => {
      this.handleSearch();
    });
  }
  private unBindEvent() {
    pubsub.unsubscribe(updateTodoBonusEventToken);
    pubsub.unsubscribe(batchCreatedTodoEventToken);
  }
}
